<ion-header class="header ion-no-border" mode="ios">
  <ion-toolbar class="highlight-second">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/" text="" icon="chevron-back" *ngIf="back === 'ionic'"></ion-back-button>
      <ion-button defaultHref="/" text="" icon="chevron-back" *ngIf="back === 'native' || back === 'modal'" (click)="back === 'native' ? navigationService.goBack(backUrl) : closeModal()">
        <ion-icon name="chevron-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title class="header__title">
      {{pageTitle != 'null' ? pageTitle : ''}}
      <ion-skeleton-text *ngIf="pageTitle == 'null'" [animated]="true" style="width: 150px; margin: auto;"></ion-skeleton-text>
    </ion-title>
    <ion-buttons slot="end">
      <ng-container *ngIf="catalogItem && isFavorite">
        <ion-button (click)="setFavorite()">
          <ion-icon name="{{catalogItem.isFavorite ? 'heart' : 'heart-outline'}}"></ion-icon>
        </ion-button>
      </ng-container>
      <ion-button *ngIf="isShare" (click)="share()">
        <ion-icon name="share-outline"></ion-icon>
      </ion-button>
      <ion-button *ngIf="catalogItem && isEdit" (click)="edit()">
        <ion-icon name="create-outline"></ion-icon>
      </ion-button>
      <ion-button *ngIf="catalogItem && isRemove" (click)="remove()">
        <ion-icon name="trash-outline"></ion-icon>
      </ion-button>
      <ion-button shape="round" color="danger" class="button button_add" *ngIf="isNew" (click)="goToNew()">
        <ion-icon name="add-outline"></ion-icon>
      </ion-button>
      <ion-button *ngIf="chatLeaveId"  color="danger" class="button" (click)="chatLeave()">
        <ion-icon name="trash-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
